/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./mBtnIndex.vue?vue&type=template&id=718927d8&scoped=true"
import script from "./mBtnIndex.vue?vue&type=script&lang=js"
export * from "./mBtnIndex.vue?vue&type=script&lang=js"
import style0 from "./mBtnIndex.vue?vue&type=style&index=0&id=718927d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718927d8",
  null
  
)

export default component.exports